export const TITLE = {
	REMOVE_EXTENSION: 'Remove extension',
	REMOVE_MESSENGER: 'Remove messenger',
	END_WORK: 'The working day will be completed.',
};
export const TEXT = {
	REMOVE_EXTENSION: 'Are you sure you want to remove this extension?',
	REMOVE_MESSENGER: 'Are you sure you want to remove this messenger?',
	END_WORK: 'It will not be possible to press the "Check Out" button again. The "Check In" button will be active the next business day.',
};

export const duties = [
	{
		text: "Date from",
		value: "date"
	},
	{
		text: "Date from",
		value: "date"
	},
];
export const accountTableInventory = [
	{
		settings: true,
		text: "Parent",
		value: "name",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Inventory",
		value: "type",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Series",
		value: "series",
		func: false,
		sortable: true,
	}

];
export const accountTableDocuments = [
	{
		settings: true,
		text: "Type",
		value: "type_name",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Name",
		value: "document_name",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'view',
				text: 'View',
				icon: { value: 'icon_view', w: 20, h: 20 },
			}
		]
	},
];
export const accountTabStatementsItems = [
	{
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: "filter_id",
		model: { value: 'list' },
		func: true,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Work type",
		value: "month_employee",
		valueFilter: "filter_month_employee",
		model: { value: 'list' },
		func: true,
		sortable: true,
		modValue: 'month_employee'
	},
	{
		settings: true,
		text: "Month",
		value: "month",
		valueFilter: "filter_month",
		model: { value: 'list' },
		func: true,
		sortable: true,
		footer: "count",
	},
	{
		width: '180px',
		settings: true,
		text: "Created",
		value: "created",
		valueFilter: "filter_created",
		model: { value: 'date' },
		func: true,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Department",
		value: "department",
		valueFilter: "filter_department",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Employee",
		value: "employee",
		valueFilter: "filter_employee",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Manager",
		value: "manager",
		valueFilter: "filter_manager",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Bonus",
		value: "bonus",
		valueFilter: "filter_bonus",
		model: { value: 'number' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Charge",
		value: "charge",
		valueFilter: "filter_charge",
		model: { value: 'number' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Salary",
		value: "salary",
		valueFilter: "filter_salary",
		model: { value: 'number' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Total",
		value: "total",
		valueFilter: "filter_total",
		model: { value: 'number' },
		func: true,
		sortable: true,
	},

	{
		settings: true,
		buttons: [
			// {
			// 	perm: true,
			// 	value: 'edit1',
			// 	text: 'Edit customer',
			// 	icon: { value: 'edit', w: 18, h: 18 },
			// },
			{
				perm: true,
				value: 'delete1',
				text: 'Delete statements',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},

];
export const settingTabVersions = [
	{
		width: '60px',
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: "filter_id",
		model: { value: 'list' },
		func: true,
		sortable: true,
		footer: "count",
	},
	{
		width: '180px',
		settings: true,
		text: "Date",
		value: "date",
		valueFilter: "filter_date",
		model: { value: 'date' },
		func: true,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Version",
		value: "version",
		valueFilter: "filter_version",
		model: { value: 'version' },
		func: true,
		sortable: true,
	},

	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit1',
				text: 'Edit version',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete1',
				text: 'Delete version',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},

];
export const accountTabMyStatementsItems = [
	{
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: "filter_id",
		model: { value: 'list' },
		func: true,
		sortable: true,
		footer: "count",
	},
	// {
	// 	settings: true,
	// 	text: "Employee",
	// 	value: "employee",
	// 	valueFilter: "filter_employee",
	// 	model: { value: 'list' },
	// 	func: true,
	// 	sortable: true,
	// },
	{
		settings: true,
		text: "Month",
		value: "month",
		valueFilter: "filter_month",
		model: { value: 'list' },
		func: true,
		sortable: true,
		footer: "count",
	},
	{
		width: '180px',
		settings: true,
		text: "Created",
		value: "created",
		valueFilter: "filter_created",
		model: { value: 'date' },
		func: true,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Department",
		value: "department",
		valueFilter: "filter_department",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Bonus",
		value: "bonus",
		valueFilter: "filter_bonus",
		model: { value: 'number' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Charge",
		value: "charge",
		valueFilter: "filter_charge",
		model: { value: 'number' },
		func: true,
		sortable: true,
	},

	{
		settings: true,
		text: "Manager",
		value: "manager",
		valueFilter: "filter_manager",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Salary",
		value: "salary",
		valueFilter: "filter_salary",
		model: { value: 'number' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Total",
		value: "total",
		valueFilter: "filter_total",
		model: { value: 'number' },
		func: true,
		sortable: true,
	},

	// {
	// 	settings: true,
	// 	buttons: [
	// 		// {
	// 		// 	perm: true,
	// 		// 	value: 'edit1',
	// 		// 	text: 'Edit customer',
	// 		// 	icon: { value: 'edit', w: 18, h: 18 },
	// 		// },
	// 		{
	// 			perm: true,
	// 			value: 'delete1',
	// 			text: 'Delete customer',
	// 			icon: { value: 'deleteItem', w: 18, h: 18 },
	// 		}
	// 	]
	// },

];
export const accountTabVacation = [
	{
		width: '80px',
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: "filter_id",
		model: { value: 'list' },
		func: true,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Date created",
		value: "created",
		valueFilter: "filter_date",
		model: { value: 'date' },
		func: true,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Vacation Days",
		value: "dates",
		valueFilter: "filter_date",
		model: { value: 'date' },
		func: true,
		sortable: true,
		footer: "count",
		modValue: 'vacationDays'
	},
	{
		settings: true,
		text: "Count Days",
		value: "count",
		valueFilter: "filter_count",
		model: { value: 'number' },
		func: true,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Employee",
		value: "employee",
		valueFilter: "filter_employee",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},

	{
		settings: true,
		text: "Note",
		value: "note",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Head",
		value: "head",
		valueFilter: "filter_head",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		width: '130px',
		text: "Head status",
		value: "head_status",
		action: "head_action",
		settings: true,
		func: false,
		sortable: true,
		isSwitch: true,
	},
	{
		width: '130px',
		text: "Super head status",
		value: "main_status",
		action: "main_action",
		settings: true,
		func: false,
		sortable: true,
		isSwitch: true,
	},
	{
		width: '130px',
		text: "Refused",
		value: "refused",
		actionGroup: [ "head_action", "main_action" ],
		actionGroupCancel: [ "head_status", "main_status" ],
		settings: true,
		func: false,
		sortable: true,
		isSwitch: true,
	},

	{
		settings: true,
		text: "Refused by",
		value: "refused_by",
		valueFilter: "filter_refused_by",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,

		buttons: [
			{
				perm: true,
				value: 'editMod',
				text: 'Edit vacation',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'deleteMod',
				text: 'Delete vacation',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
export const accountTabAllUsersComments = [

	{
		width: '90px',
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: "filter_id",
		model: { value: 'list' },
		func: true,
		sortable: true,
		footer: "count",
	},
	{
		width: '180px',
		settings: true,
		text: "Date created",
		value: "date",
		valueFilter: "filter_date",
		model: { value: 'date' },
		func: true,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Employee",
		value: "employee",
		valueFilter: "filter_employee",
		model: { value: 'list' },
		func: true,
		sortable: true,
		modValue: 'linkUser',
	},
	// {
	// 	settings: true,
	// 	text: "Manager",
	// 	value: "created_by",
	// 	valueFilter: "filter_created_by",
	// 	model: { value: 'list' },
	// 	func: true,
	// 	sortable: true,
	// },
	{
		settings: true,
		text: "Note",
		value: "note",
		func: false,
		sortable: true,
	},
	{
		width: '130px',
		text: "Read status",
		value: "status",
		settings: true,
		func: false,
		sortable: true,
		isSwitch: true,
	},
];
export const salaryHistorySlideAccrual = [
	{
		width: '100px',
		settings: true,
		text: "Date",
		value: "date",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Type",
		value: "type",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Manager",
		value: "manager",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Notes",
		value: "notes",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Sum",
		value: "sum",
		valueFilter: 'filter_sum',
		model: { value: 'number' },
		func: false,
		sortable: true,
		dollar: true,
		footer: "sumNotCut"
	},
];
// дата действие депртамент. нейм, адрес вход, адрес выход
export const accountTabGeo = [
	{
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: "filter_id",
		model: { value: 'list' },
		func: true,
		sortable: true,
		footer: "count",
	},
	{
		width: '180px',
		settings: true,
		text: "Date",
		value: "date",
		valueFilter: "filter_date",
		model: { value: 'date' },
		func: true,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Department",
		value: "department",
		valueFilter: "filter_department",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},

	{
		settings: true,
		text: "Employee",
		value: "employee",
		valueFilter: "filter_employee",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},

	{
		settings: true,
		text: "Check in",
		value: "geo_in",
		valueFilter: "filter_month",
		model: { value: 'list' },
		func: false,
		sortable: true,
	},
	{
		text: "Map",
		settings: true,
		buttons: [
			{
				hasData: 'coordinates_in',
				perm: true,
				value: 'coordinates_in',
				text: 'Check in Geo',
				icon: { value: 'mapPin', w: 18, h: 18 },
			}
		]
	},
	{
		settings: true,
		text: "Check out",
		value: "geo_out",
		valueFilter: "filter_month",
		model: { value: 'list' },
		func: false,
		sortable: true,
	},

	{
		text: "Map",
		settings: true,
		buttons: [
			{
				hasData: 'coordinates_out',
				perm: true,
				value: 'coordinates_out',
				text: 'Check out Geo',
				icon: { value: 'mapPin', w: 18, h: 18 },
			}
		]
	},
];
export const salaryHistorySlidePay = [
	{
		width: '100px',
		settings: true,
		text: "Date",
		value: "date",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Manager",
		value: "manager",
		func: false,
		model: { value: 'list', },
		sortable: true
	},
	{
		settings: true,
		text: "Notes",
		value: "notes",
		valueFilter: "filter_notes",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		func: false,
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Old balance",
		value: "old_balance",
		// valueFilter: 'filter_sum',
		// model: { value: 'number' },
		// func: false,
		sortable: true,
		dollar: true,
		// footer: "sum"
	},
	{
		settings: true,
		text: "New balance",
		value: "new_balance",
		// valueFilter: 'filter_sum',
		// model: { value: 'number' },
		// func: false,
		sortable: true,
		dollar: true,
		// footer: "sum"
	},

	// {
	// 	settings: true,
	// 	buttons: [
	// 		// {
	// 		// 	perm: true,
	// 		// 	value: 'edit1',
	// 		// 	text: 'Edit customer',
	// 		// 	icon: { value: 'edit', w: 18, h: 18 },
	// 		// },
	// 		{
	// 			perm: true,
	// 			value: 'delete1',
	// 			text: 'Delete salary payment',
	// 			icon: { value: 'deleteItem', w: 18, h: 18 },
	// 		}
	// 	]
	// },
];
export const salaryHistorySlidePayAdmin = [
	{
		width: '100px',
		settings: true,
		text: "Date",
		value: "date",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Manager",
		value: "manager",
		func: false,
		model: { value: 'list', },
		sortable: true
	},
	{
		settings: true,
		text: "Notes",
		value: "notes",
		valueFilter: "filter_notes",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		func: false,
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Old balance",
		value: "old_balance",
		// valueFilter: 'filter_sum',
		// model: { value: 'number' },
		// func: false,
		sortable: true,
		dollar: true,
		// footer: "sum"
	},
	{
		settings: true,
		text: "New balance",
		value: "new_balance",
		// valueFilter: 'filter_sum',
		// model: { value: 'number' },
		// func: false,
		sortable: true,
		dollar: true,
		// footer: "sum"
	},

	{
		settings: true,
		buttons: [
			// {
			// 	perm: true,
			// 	value: 'edit1',
			// 	text: 'Edit customer',
			// 	icon: { value: 'edit', w: 18, h: 18 },
			// },
			{
				perm: true,
				value: 'delete1',
				text: 'Delete salary payment',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
export const accountTabSalaryHistory = [
	{
		settings: true,
		text: "ID",
		value: "id",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Month",
		value: "month",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		width: '180px',
		settings: true,
		text: "Date pay",
		value: "datePay",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Manger",
		value: "manger",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Notes",
		value: "notes",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Salary",
		value: "salary",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Pay",
		value: "pay",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Balance old",
		value: "balanceOld",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Balance",
		value: "balance",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Time",
		value: "time",
		func: false,
		sortable: true,
	},
];
export const contactsTypeList = [
	{
		value: 'Extension',
		id: 0,
	},
	{
		value: 'Phone',
		id: 1,
	},
	{
		value: 'Email',
		id: 2,
	},
	{
		value: 'Telegram',
		id: 3,
	},
	{
		value: 'Whatsapp',
		id: 4,
	},
	{
		value: 'Viber',
		id: 5,
	},
];

export const getPermissionsStateTEST = {
	"getPermissionsState": [
		{
			hide: false,
			id: 89,
			name: "Account",
			selected: true,
			"children": [
				{
					"hide": false,
					"id": 8,
					"name": "Create",
					"selected": false
				},
				{
					"hide": false,
					"id": 9,
					"name": "Edit",
					"selected": false
				},
				{
					"hide": false,
					"id": 11,
					"name": "Delete",
					"selected": false
				},
				{
					"hide": false,
					"id": 72,
					"name": "Export",
					"selected": false
				}
			],
		},
		{
			hide: false,
			id: 82,
			name: "Account2",
			selected: true,
			"children": [
				{
					"hide": false,
					"id": 8,
					"name": "Create",
					"selected": false
				},
				{
					"hide": false,
					"id": 9,
					"name": "Edit",
					"selected": false
				},
				{
					"hide": false,
					"id": 11,
					"name": "Delete",
					"selected": false
				},
				{
					"hide": false,
					"id": 72,
					"name": "Export",
					"selected": false
				}
			],
		},
		{
			hide: false,
			id: 83,
			name: "Account2",
			selected: true,
			"children": [
				{
					"hide": false,
					"id": 95,
					"name": "My Info",
					"selected": false,
					"children": [
						{
							"hide": false,
							"id": 8,
							"name": "Create",
							"selected": false
						},
						{
							"hide": false,
							"id": 9,
							"name": "Edit",
							"selected": false
						},
						{
							"hide": false,
							"id": 11,
							"name": "Delete",
							"selected": false
						},
						{
							"hide": false,
							"id": 72,
							"name": "Export",
							"selected": false
						}
					]
				},
				{
					"hide": false,
					"id": 8,
					"name": "Create",
					"selected": false
				},
				{
					"hide": false,
					"id": 9,
					"name": "Edit",
					"selected": false
				},
				{
					"hide": false,
					"id": 11,
					"name": "Delete",
					"selected": false
				},
				{
					"hide": false,
					"id": 72,
					"name": "Export",
					"selected": false
				}
			],
		},
	]
};
